import { Injectable } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy()
@Injectable({
    providedIn: 'root'
})
export class PreviousRouteService {
    private readonly previousUrls: string[] = [];
    private readonly MAX_PREVIOUS_URLS = 5;

    constructor() {}

    addPreviousUrl(url: string): void {
        if (this.previousUrls.length === this.MAX_PREVIOUS_URLS) {
            this.previousUrls.shift();
        }
        this.previousUrls.push(url);
    }

    getPreviousUrl(): string {
        return this.previousUrls[this.previousUrls.length - 1] || null;
    }

    getPreviousUrls(): string[] {
        return this.previousUrls;
    }
}
